import { useCallback, useState } from 'react';

const useModal = (): [boolean, () => void, () => void] => {
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);

  return [open, openDialog, closeDialog];
};

export default useModal;
